import React, { useState } from "react";
import { Wrapper } from "../../../components/Control/Flexbox";
import Input from "../../../components/Control/Input";
import Paper from "@material-ui/core/Paper";
import { Typography } from "@material-ui/core";

import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import { makeStyles } from "@material-ui/core/styles";

const Check1 = ({ pirData, spec, index, idx }) => {
  const [render, setRender] = useState(false);
  const useStyles = makeStyles({
    root: {
      background: `${
        pirData.pir[index].list[idx].firstcheck_result === "OK"
          ? "#5cb660"
          : "#ff8787"
      }`,
    },
    select: {
      color: `${
        pirData.pir[index].list[idx].firstcheck_result === "OK"
          ? "#111 !important"
          : "#111"
      }`,
    },
    label: {
      textTransform: "capitalize",
    },
  });
  const checkResultOkORNot = (index, idx) => {
    if (
      spec.first_check_p1_color === "#f7aeae" ||
      spec.first_check_p2_color === "#f7aeae" ||
      spec.first_check_p3_color === "#f7aeae" ||
      spec.first_check_p4_color === "#f7aeae" ||
      spec.first_check_p5_color === "#f7aeae"
    ) {
      pirData.pir[index].list[idx].firstcheck_result = "NOT OK";
      return;
    }
    pirData.pir[index].list[idx].firstcheck_result = "OK";
  };

  function handleChangePirList({ target }, index, idx) {
    const value = target.type === "checkbox" ? target.checked : target.value;
    pirData.pir[index].list[idx][target.name] = value;
    setRender((prev) => !prev);
  }

  function handleChangePirListSetup(
    { target },
    index,
    idx,
    mean,
    utolerance,
    ltolerance,
    old_utl,
    old_ltl,
    check4_symbol,
    checkbox4_num
  ) {
    const value = target.type === "checkbox" ? target.checked : target.value;
    pirData.pir[index].list[idx][target.name] = value;
    let utl;
    let ltl;
    let uv;
    let lv;
    //max
    if (check4_symbol && checkbox4_num) {
      if (check4_symbol === "<=") {
        if (value <= checkbox4_num) {
          const name = `${target.name}_color`;
          pirData.pir[index].list[idx][name] = "#a4d1a4";
          setRender((prev) => !prev);
        } else {
          const name = `${target.name}_color`;
          pirData.pir[index].list[idx][name] = "#f7aeae";
          setRender((prev) => !prev);
        }
      }
      //min
      if (check4_symbol === ">=") {
        if (value >= checkbox4_num) {
          const name = `${target.name}_color`;
          pirData.pir[index].list[idx][name] = "#a4d1a4";
          setRender((prev) => !prev);
        } else {
          const name = `${target.name}_color`;
          pirData.pir[index].list[idx][name] = "#f7aeae";
          setRender((prev) => !prev);
        }
      }
    }

    if (old_utl || old_ltl) {
      utl = parseFloat(old_utl);
      ltl = parseFloat(old_ltl);
      const mean = (utl + ltl) / 2;
      uv = (mean + utl) / 2;
      lv = (mean + ltl) / 2;
    } else {
      utl = parseFloat(mean) + parseFloat(utolerance);
      ltl = parseFloat(mean) - parseFloat(ltolerance);

      uv = parseFloat(mean) + parseFloat(utolerance) / 2;
      lv = parseFloat(mean) - parseFloat(ltolerance) / 2;
    }

    if (value > utl || value < ltl) {
      const name = `${target.name}_color`;
      pirData.pir[index].list[idx][name] = "#f7aeae";
      setRender((prev) => !prev);
    } else if ((uv < value && value <= utl) || (lv > value && value >= ltl)) {
      const name = `${target.name}_color`;
      pirData.pir[index].list[idx][name] = "#fbfbac";
      setRender((prev) => !prev);
    } else if (value >= lv && value <= uv) {
      const name = `${target.name}_color`;
      pirData.pir[index].list[idx][name] = "#a4d1a4";
      setRender((prev) => !prev);
    }

    if (value === "") {
      const name = `${target.name}_color`;
      pirData.pir[index].list[idx][name] = "#ffffff";
    }
    checkResultOkORNot(index, idx);
  }

  const handleminmaxColor = ({ target }, index, idx) => {
    console.log(target);
  };
  const classes = useStyles();
  return (
    <Wrapper className="pir-modal-container">
      <Input
        name="parameter"
        label="Parameter"
        style={{ width: "230px" }}
        autoComplete="off"
        type="text"
        variant="filled"
        readOnly
        value={spec.parameter}
      />
      <Input
        name="specification"
        label="Specification"
        style={{ width: "230px" }}
        autoComplete="off"
        type="text"
        variant="filled"
        readOnly
        value={spec.specification}
      />
      {(spec.appearance === "check1" ||
        spec.appearance === "check2" ||
        spec.appearance === "check4") && (
        <Input
          name="first_check_p1"
          label="1"
          type="number"
          variant="filled"
          autoComplete="off"
          style={{ width: "100px" }}
          inputProps={{
            step: 0.01,
            style: {
              borderColor: spec.first_check_p1_color,
              backgroundColor: spec.first_check_p1_color,
            },
          }}
          onChange={(e) =>
            handleChangePirListSetup(
              e,
              index,
              idx,
              spec.mean,
              spec.utolerance,
              spec.ltolerance,
              spec.utl,
              spec.ltl,
              spec.check4_symbol,
              spec.checkbox4_num
            )
          }
          defaultValue={spec.first_check_p1}
        />
      )}
      {spec.appearance === "check3" && (
        <Input
          variant="filled"
          autoComplete="off"
          name="first_check_p1"
          label="1"
          style={{ width: "100px" }}
          defaultValue={spec.first_check_p1}
          onChange={(e) => handleChangePirList(e, index, idx)}
        />
      )}
      {/* second check */}
      {(spec.appearance === "check1" ||
        spec.appearance === "check2" ||
        spec.appearance === "check4") && (
        <Input
          name="first_check_p2"
          label="2"
          type="number"
          variant="filled"
          autoComplete="off"
          style={{ width: "100px" }}
          inputProps={{
            step: 0.01,
            style: {
              borderColor: spec.first_check_p2_color,
              backgroundColor: spec.first_check_p2_color,
            },
          }}
          onChange={(e) =>
            handleChangePirListSetup(
              e,
              index,
              idx,
              spec.mean,
              spec.utolerance,
              spec.ltolerance,
              spec.utl,
              spec.ltl,
              spec.check4_symbol,
              spec.checkbox4_num
            )
          }
          defaultValue={spec.first_check_p2}
        />
      )}
      {spec.appearance === "check3" && (
        <Input
          variant="filled"
          autoComplete="off"
          name="first_check_p2"
          style={{ width: "100px" }}
          label="2"
          defaultValue={spec.first_check_p2}
          onChange={(e) => handleChangePirList(e, index, idx)}
        />
      )}
      {/* Third Check */}
      {(spec.appearance === "check1" ||
        spec.appearance === "check2" ||
        spec.appearance === "check4") && (
        <Input
          name="first_check_p3"
          label="3"
          type="number"
          variant="filled"
          autoComplete="off"
          style={{ width: "100px" }}
          inputProps={{
            step: 0.01,
            style: {
              borderColor: spec.first_check_p3_color,
              backgroundColor: spec.first_check_p3_color,
            },
          }}
          onChange={(e) =>
            handleChangePirListSetup(
              e,
              index,
              idx,
              spec.mean,
              spec.utolerance,
              spec.ltolerance,
              spec.utl,
              spec.ltl,
              spec.check4_symbol,
              spec.checkbox4_num
            )
          }
          defaultValue={spec.first_check_p3}
        />
      )}
      {spec.appearance === "check3" && (
        <Input
          variant="filled"
          autoComplete="off"
          name="first_check_p3"
          style={{ width: "100px" }}
          label="3"
          defaultValue={spec.first_check_p3}
          onChange={(e) => handleChangePirList(e, index, idx)}
        />
      )}
      {/* Fourth Check */}
      {(spec.appearance === "check1" ||
        spec.appearance === "check2" ||
        spec.appearance === "check4") && (
        <Input
          name="first_check_p4"
          label="4"
          type="number"
          variant="filled"
          autoComplete="off"
          style={{ width: "100px" }}
          inputProps={{
            step: 0.01,
            style: {
              borderColor: spec.first_check_p4_color,
              backgroundColor: spec.first_check_p4_color,
            },
          }}
          onChange={(e) =>
            handleChangePirListSetup(
              e,
              index,
              idx,
              spec.mean,
              spec.utolerance,
              spec.ltolerance,
              spec.utl,
              spec.ltl,
              spec.check4_symbol,
              spec.checkbox4_num
            )
          }
          defaultValue={spec.first_check_p4}
        />
      )}
      {spec.appearance === "check3" && (
        <Input
          variant="filled"
          autoComplete="off"
          name="first_check_p4"
          style={{ width: "100px" }}
          label="4"
          defaultValue={spec.first_check_p4}
          onChange={(e) => handleChangePirList(e, index, idx)}
        />
      )}
      {/* Fifth Check */}
      {(spec.appearance === "check1" ||
        spec.appearance === "check2" ||
        spec.appearance === "check4") && (
        <Input
          name="first_check_p5"
          label="5"
          type="number"
          style={{ width: "100px" }}
          variant="filled"
          autoComplete="off"
          inputProps={{
            step: 0.01,
            style: {
              borderColor: spec.first_check_p5_color,
              backgroundColor: spec.first_check_p5_color,
            },
          }}
          onChange={(e) =>
            handleChangePirListSetup(
              e,
              index,
              idx,
              spec.mean,
              spec.utolerance,
              spec.ltolerance,
              spec.utl,
              spec.ltl,
              spec.check4_symbol,
              spec.checkbox4_num
            )
          }
          defaultValue={spec.first_check_p5}
        />
      )}
      {spec.appearance === "check3" && (
        <Input
          variant="filled"
          autoComplete="off"
          name="first_check_p5"
          style={{ width: "100px" }}
          label="5"
          defaultValue={spec.first_check_p5}
          onChange={(e) => handleChangePirList(e, index, idx)}
        />
      )}
      {/* unit */}
      <Input
        name="unit"
        style={{ width: "100px" }}
        variant="filled"
        autoComplete="off"
        onChange={(e) => handleChangePirList(e, index, idx)}
        defaultValue={spec.specUnit}
        type="text"
        label="Unit"
        inputProps={{ readOnly: true }}
      />
      {/* Results */}
      {spec.appearance === "check3" ? (
        <FormControl
          style={{
            width: "120px",
            marginLeft: "0.55rem",
            // backgroundColor: "#5cb660 !important",
          }}
          variant="filled"
          // className="select-field"
          classes={{
            root: classes.root,
            label: classes.label,
            // select: classes.select,
          }}
        >
          <InputLabel>Status</InputLabel>
          <Select
            name="firstcheck_result"
            defaultValue={spec.firstcheck_result}
            onChange={(e) => handleChangePirList(e, index, idx)}
            classes={{
              select: classes.select,
            }}
          >
            <MenuItem value="OK">OK</MenuItem>
            <MenuItem value="NOT OK">NOT OK</MenuItem>
          </Select>
        </FormControl>
      ) : (
        <Paper
          name="firstcheck_result"
          elevation={2}
          style={{
            width: "122px",
            height: "55px",
            display: "flex",
            alignItems: "center",
            marginLeft: "8px",
            backgroundColor: `${
              spec.firstcheck_result === "OK" ? "#5cb660" : "#ff8787"
            }`,
          }}
        >
          <Typography style={{ marginLeft: "1rem" }}>
            {spec.firstcheck_result === "OK" ? "OK" : "NOT OK"}
          </Typography>
        </Paper>
      )}
    </Wrapper>
  );
};

export default Check1;
